import { checkingPreload, unCheckingPreload } from '../loading';
import { setGenerating, setLastGeneratedResult, setRequestShiftList } from './slice';
import { adjustWithAiService, generateShiftsService, getPlaningShiftRequestService, saveDraftService } from '../../services/shift-generator.service';



export const getPlaningShiftRequestStore = (): any => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        // dispatch(setGenerating(true));

        const result = await getPlaningShiftRequestService();
        if (result.ok) {
           await dispatch(setRequestShiftList(result.data));
        }

        // dispatch(setGenerating(false));
        dispatch(unCheckingPreload());

        return result;
    };
};

export const storeGenerateShifts = (data: any, historicalFile?: File | null): any => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        dispatch(setGenerating(true));

        const result = await generateShiftsService(data, historicalFile);

        if (result.ok) {
            dispatch(setLastGeneratedResult(result.data));
        }

        dispatch(setGenerating(false));
        dispatch(unCheckingPreload());

        return result;
    };
};

export const adjustScheduleWithAiStore = (prompt: string, requestId: string, generateExplanation: boolean = true): any => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        dispatch(setGenerating(true));
        
        const payload = {
           prompt,
           requestId,
           generateExplanation
        };

        const result = await adjustWithAiService(payload);

        if (result && result.ok && result.data) {
            dispatch(setLastGeneratedResult(result.data));
            result.message = result.message || "Ajuste aplicado";
        }

        dispatch(setGenerating(false));
        dispatch(unCheckingPreload());

        return result;
    };
};

export const storeSaveDraft = (data: any): any => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        dispatch(setGenerating(true));
        
        const result = await saveDraftService(data);

        dispatch(setGenerating(false));
        dispatch(unCheckingPreload());

        return result;
    };
};
